module.exports = __webpack_public_path__ + "static/assets/9a96a29ee6161e7bd4cf113b951126ee.svg";